import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadProgressComponent } from 'src/app/shared/components/upload-progress/upload-progress.component';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';

export class MediaItem {
  url: string = '';
  type: 'image' | 'video' = 'image'; // 'image' or 'video'
}

@Component({
  selector: 'app-projectgallery',
  templateUrl: './projectgallery.component.html',
  styleUrls: ['./projectgallery.component.css']
})
export class ProjectgalleryComponent implements OnInit {
  @Output() showNextPage: EventEmitter<number> = new EventEmitter();
  @ViewChild('mediaFileInput') mediaFileInput: ElementRef;
  
  propertyMedia: Array<MediaItem> = [];
  
  dragOverIndex: number = -1;
  selectedProperty: any;
  
  // Upload limits
  minUploads = 5;
  maxUploads = 20;
  
  // Supported file types
  imageFormats = 'image/*';
  videoFormats = 'video/mp4,video/webm,video/ogg,video/quicktime';
  allFormats = 'image/*,video/mp4,video/webm,video/ogg,video/quicktime';

  constructor(
    private modalService: NgbModal,
    private rsbService: RsbService,
    private lookupModel: RsbLookupModel,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.selectedProperty = this.lookupModel.getVendorProperty() ? this.lookupModel.getVendorProperty() : null;
    if(this.selectedProperty && this.selectedProperty.images) {
      this.propertyMedia = this.selectedProperty.images;
    }
  }

  initializeMediaSlots(): void {
    // No longer needed - we only store uploaded items
  }

  getUploadedCount(): number {
    return this.propertyMedia.filter(media => media.url !== '').length;
  }

  canSubmit(): boolean {
    return this.getUploadedCount() >= this.minUploads;
  }

  onDragOver(event: DragEvent, index: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragOverIndex = index;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragOverIndex = -1;
  }

  onDrop(event: DragEvent, index: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragOverIndex = -1;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleMultipleFiles(files);
    }
  }

  handleMultipleFiles(files: FileList): void {
    const filesArray = Array.from(files);
    
    // Check if adding these files would exceed max uploads
    const totalFiles = this.getUploadedCount() + filesArray.length;
    if (totalFiles > this.maxUploads) {
      alert(`Maximum ${this.maxUploads} files allowed. You're trying to upload ${totalFiles} files.`);
      return;
    }

    // Process each file
    filesArray.forEach((file, index) => {
      this.handleFileUpload(file, index);
    });
  }

  handleFileUpload(file: File, index: number): void {
    if (!file) return;

    const isImage = file.type.startsWith('image/');
    const isVideo = file.type.startsWith('video/');

    if (!isImage && !isVideo) {
      alert('Please upload an image or video file.');
      return;
    }

    // Upload both images and videos directly without cropping
    const mediaType: 'image' | 'video' = isImage ? 'image' : 'video';
    this.uploadMedia(file, mediaType);
  }

  uploadMedia(file: File, type: 'image' | 'video'): void {
    const modalRef = this.modalService.open(UploadProgressComponent, { 
      windowClass: 'signInForm', 
      backdrop: 'static', 
      keyboard: false 
    });
    modalRef.componentInstance.file = file;
    modalRef.result.then((path: any) => {
      if (path) {
        this.updateMediaItem(0, path?.image, type, false);
      }
    });
  }

  updateMediaItem(index: number, url: string, type: 'image' | 'video', markDefault: boolean): void {
    // Always add as new item (append to array)
    if(markDefault) {
      // Move to front
      this.propertyMedia.unshift({ url, type });
      this.selectedProperty.propertyPreviewImage = url;
    } else {
      // Add to end
      this.propertyMedia.push({ url, type });
    }
    this.cdr.detectChanges();
  }

  removeMedia(index: number): void {
    this.propertyMedia.splice(index, 1);
    this.cdr.detectChanges();
  }

  onFileSelected(event: any, index: number): void {
    const files = event.target?.files;
    if (files && files.length > 0) {
      this.handleMultipleFiles(files);
    }
  }

  openFileDialog(): void {
    if (this.mediaFileInput && this.mediaFileInput.nativeElement) {
      this.mediaFileInput.nativeElement.click();
    }
  }

  back(): void {
    this.showNextPage.emit(2);
  }

  submit(): void {
    // Validate minimum uploads
    const uploadedCount = this.getUploadedCount();
    if (uploadedCount < this.minUploads) {
      alert(`Please upload at least ${this.minUploads} images/videos. Currently uploaded: ${uploadedCount}`);
      return;
    }

    let property = this.lookupModel.getVendorProperty();
    // Save all uploaded media
    property.images = this.propertyMedia;
    if (!property.projectId) {
      property.projectId = 'abc';
    }

    if(property.propertyPreviewImage) {
      property.propertyPreviewImage = this.propertyMedia[0].url;
    }

    this.lookupModel.setVendorProperty(property);
    this.showNextPage.emit(4);
  }

}

